import React from 'react';
export function StickyBar() {
  return <div className="bg-navy-950 text-white py-2 px-4 text-center text-sm font-medium sticky top-0 z-50 shadow-md" data-id="element-365">
      <span className="inline-block animate-pulse mr-2" data-id="element-366">🔥</span>
      OFERTA ESPECIAL DE LANZAMIENTO
    </div>;
}